import React from 'react';
import './Home.css';
import { Link } from 'react-router-dom';
import tpscover from '../assets/images/futuraTPScover.png';
import mfpCover from '../assets/images/mfpCover.png';
import resume from '../assets/UX-Resume-2026.pdf';

export default function Home() {
  return (
    <div className="home">

      {/* Hero */}
      <section className="hero">
        <div className="hero-content">
          <div className="hero-status">
            <span className="hero-status-dot">●</span>
            Currently leading product &amp; UX at an early-stage AI startup
          </div>
          <h1>Elizabeth Harrington, UX Designer &amp; Product Manager</h1>
          <p className="hero-blurb">
            I'm a UX designer and product manager with 4 years building digital products for startups, small businesses, and nonprofits. I combine user research, hands-on design, and front-end development to ship products people actually use.
          </p>
          <div className="hero-buttons">
            <Link to="/projects">
              <button className="btn-primary">View Projects</button>
            </Link>
            <Link to="/contact">
              <button className="btn-secondary">About Me</button>
            </Link>
          </div>
        </div>
      </section>

      {/* Selected Work */}
      <section className="selected-work">
        <div className="selected-work-inner">
          <h2 className="section-heading">Selected Work</h2>
          <p className="section-sub">A few recent projects I'm most proud of.</p>

          <div className="featured-grid">

            <Link to="/projects/cani" className="featured-card-link">
              <div className="featured-card">
                <div className="featured-card-img">
                  <img src="/images/cani-main-hero.png" alt="CANI main site" style={{width:'100%',height:'100%',objectFit:'cover',display:'block'}} />
                </div>
                <div className="featured-card-body">
                  <h3 className="featured-card-title">CANI — Dual Website Launch</h3>
                  <div className="featured-tags">
                    <span className="featured-tag">Web Design</span>
                    <span className="featured-tag">HubSpot · WordPress</span>
                  </div>
                  <p className="featured-description">
                    Designed and shipped two production websites in 12 weeks — one on WordPress, one on HubSpot — with a shared design system supporting an AI-driven RevOps and go-to-market initiative. WCAG 2.1 AA compliant throughout.
                  </p>
                  <span className="featured-link">View Case Study →</span>
                </div>
              </div>
            </Link>

            <Link to="/projects/sonos-app" className="featured-card-link">
              <div className="featured-card">
                <div className="featured-card-img">
                  <img src="/images/sonosCover.png" alt="Sonos App Redesign" style={{width:'100%',height:'100%',objectFit:'cover',display:'block'}} />
                </div>
                <div className="featured-card-body">
                  <h3 className="featured-card-title">Sonos App Redesign</h3>
                  <div className="featured-tags">
                    <span className="featured-tag">UX Design</span>
                    <span className="featured-tag">End-to-End Redesign</span>
                  </div>
                  <p className="featured-description">
                    A full end-to-end redesign of the Sonos mobile app, applying Jesse James Garrett's Five Elements framework from research through high-fidelity prototyping. Focused on resolving the fragmented Sonos/S1 app ecosystem and creating a unified, premium control experience.
                  </p>
                  <span className="featured-link">View Case Study →</span>
                </div>
              </div>
            </Link>

          </div>
        </div>
      </section>

      {/* Other Projects */}
      <section className="projects other-projects">
        <div className="projects-inner">
          <h2>Other Projects</h2>
          <div className="projects-grid">

            <Link to="/projects/type-specimen" className="project-card-link">
              <div className="project-card">
                <div className="project-img-container">
                  <img src={tpscover} alt="Type Specimen App" className="project-img" />
                </div>
                <div className="project-info">
                  <h3>Type Specimen App</h3>
                  <p>UX Design · Figma</p>
                  <span className="view-button">View Case Study</span>
                </div>
              </div>
            </Link>

            <Link to="/projects/journey-map-report" className="project-card-link">
              <div className="project-card">
                <div className="project-img-container">
                  <img src={mfpCover} alt="Journey Map Report" className="project-img" />
                </div>
                <div className="project-info">
                  <h3>Journey Map Report</h3>
                  <p>UX Research · Figma</p>
                  <span className="view-button">View Case Study</span>
                </div>
              </div>
            </Link>

            <Link to="/projects/help-us-serve" className="project-card-link">
              <div className="project-card">
                <div className="project-img-container">
                  <img src="/images/helpusserve-hero.png" alt="Help Us Serve" className="project-img" />
                </div>
                <div className="project-info">
                  <h3>Help Us Serve — Nonprofit UX</h3>
                  <p>UX Design · WordPress · Donation Platform</p>
                  <span className="view-button">View Case Study</span>
                </div>
              </div>
            </Link>

          </div>
          <div className="other-projects-footer">
            <Link to="/projects">
              <button className="btn-all-projects">View All Projects →</button>
            </Link>
          </div>
        </div>
      </section>

      {/* Get in Touch */}
      <section className="get-in-touch">
        <div className="get-in-touch-inner">
          <p className="get-in-touch-eyebrow">GET IN TOUCH</p>
          <h2 className="get-in-touch-heading">Let's build something great together.</h2>
          <p className="get-in-touch-sub">
            Open to product, UX, and front-end opportunities. Always happy to chat about design, AI, or what I'm currently building.
          </p>
          <div className="get-in-touch-buttons">
            <a href="mailto:elizabeth10harrington@gmail.com" className="btn-contact-primary">Email Me</a>
            <a href={resume} target="_blank" rel="noopener noreferrer" className="btn-contact-secondary">View Resume</a>
          </div>
        </div>
      </section>

      {/* Studio 907 CTA */}
      <section className="studio907-cta">
        <div className="studio907-cta-inner">
          <p className="studio907-cta-eyebrow">WEB DESIGN SERVICES</p>
          <h2 className="studio907-cta-heading">Need a website built?</h2>
          <p className="studio907-cta-sub">
            I also take on freelance web design &amp; build projects through Studio 907.
          </p>
          <a href="https://studio907.io" target="_blank" rel="noopener noreferrer" className="btn-studio907">
            Visit Studio 907 →
          </a>
        </div>
      </section>

    </div>
  );
}
